module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('h2', {
    staticClass: "chap-title"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "foot1"
  })]), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Seven hundred years ago a man almost conquered the earth. He made himself master of half the known world, and inspired mankind with a fear that lasted for generations.")])]), _c('p', {
    staticClass: "noindent-t"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_vm._v("– Harold Lamb"), _c('span', {
    staticClass: "super"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#note1",
      "id": "footnote1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Napoleon associated great military achievement closely with individual military genius, saying:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Gauls were not conquered by the Roman legions, but by Caesar. It was not before the Carthaginian soldiers that Rome was made to tremble, but before Hannibal. It was not the Macedonian phalanx which reached India, but Alexander. It was not the French army that reached Weser and the Inn; it was Turenne. Prussia was not defended for seven years against the three most formidable European powers by the Prussian soldiers but by Frederick the Great."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note2",
      "id": "footnote2"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the 13th century, the Mongols established the greatest land-based empire known to history, stretching at one point from the Adriatic Sea in the west to the China Sea in the east. Initially an insignificant tribal group, the Mongols united the Inner Asian tribes under their leadership and then proceeded to make territorial conquests unequalled in speed and extent. What genius, it may be asked, was the driving force behind this achievement?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Genghis Khan was the dominant personality of the early Mongol period. To Napoleon and his era, Genghis Khan was a bloodthirsty conqueror who overwhelmed his foes with innumerable forces. It was only during the first part of the 20th century that the Mongols came to be seen as masters of warfare who won by means of skill rather than numbers, and Genghis Khan was accepted as one of most outstanding military commanders known to history. Had Napoleon made his comment in, say, 1934 he might have included Genghis Khan amongst his Great Captains. American "), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_vm._v("general MacArthur was certainly impressed. He wrote during that year in his closing report as Chief of Staff:")])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_vm._v("Were the accounts of all battles, save only those of Genghis Khan, effaced from the pages of history, and were the facts of his campaigns preserved in descriptive detail, the soldier would still possess a mine of untold wealth from which to extract nuggets of knowledge useful in moulding an army for future use. The successes of that amazing leader, beside which the triumphs of most other commanders in history pale into insignificance, are proof sufficient of his unerring instinct for the fundamental qualifications of an army."), _c('span', {
    staticClass: "super"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#note3",
      "id": "footnote3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Mongol Empire continued to expand after the death of Genghis Khan. The later conquests are closely associated with his general Sübe’etei. Not as widely known as Genghis Khan, Sübe’etei has gained a high reputation amongst military specialists. For example, famed military theorist Liddell Hart wrote: ‘As a logistical strategist Napoleon is unrivalled in history – save possibly by the Mongol Subutai, from what we can pierce together from the scanty records of his campaigns.’"), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note4",
      "id": "footnote4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though many military historians and commentators regard Genghis Khan and Sübe’etei highly, the details of their actual operations are far from clear to them. One of the most well-known Mongol campaigns is the one Genghis Khan directed against Khwarezm in what is now Uzbekistan during 1220. It has been described in detail in many popular militarily-focussed accounts, for example by Liddell Hart, Trevor Dupuy, and James Chambers. Liddell Hart and Dupuy both have high reputations as military theorists and commentators and Chambers wrote a very influential account of the Mongols’ campaigns in the Near East and Europe. However with regard to the Mongol operations against Khwarezm they fail to agree on basic details. According to Liddell Hart the Mongol left wing struck from Kashgar in the east, entering Ferghana to ‘distract’ the enemy (for locations see map 14). The Mongol main forces, in the west, struck through the Kyzylkum Desert to suddenly appear in front of Bokhara. Dupuy improved on this narrative, saying the Mongol left struck from Kashgar across the Pamir Mountains to the lower Amu Darya, an ambitious outflanking movement. Further, he proposed the main forces actually moved "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("around")]), _vm._v(" Aral Lake to reach Bokhara from the north-west. Chambers adopted the version of Liddell Hart with regard to the movement of the main army, but made the left wing execute an outflanking movement as described by Dupuy. Adding his own twist, he says another Mongol column coming from Kashgar made hit and run attacks along the entire length of the Syr Darya – the enemy front. With such major differences it is fair to wonder ‘who is right?’ In fact, as will be seen later, none are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Liddell Hart, Harold Lamb, and Michael Prawdin published articles and books during the years between the First and Second World Wars, helping to shape a new "), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_vm._v("view of the Mongols. They saw the Mongols as military supermen."), _c('span', {
    staticClass: "super"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#note5",
      "id": "footnote5"
    }
  }, [_vm._v("5")]), _vm._v(" The generals of the First World War were widely criticised for being unimaginative and ineffective, suffering great losses in dead and wounded that could have been avoided. The Mongols provided an example of how war should be waged; by means of brilliant strategy they were held to have won easy victories. Liddell Hart wrote: ‘they had grasped the essentials of strategy, while their tactical mechanism was so perfect that the higher conceptions of tactics were unnecessary’."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note6",
      "id": "footnote6"
    }
  }, [_vm._v("6")])]), _vm._v(" Harold Lamb worried that Nazi Germany had unlocked Mongol secrets: ‘There are other indications than these that readers in the Third Reich have made a close study of the Mongol campaigns and especially the Mongol technique of attack.’"), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note7",
      "id": "footnote7"
    }
  }, [_vm._v("7")])]), _vm._v(" The Western historiographical ‘Mongol supermen school’ has evolved and gained traction up until the present, sustained by a remarkable unwillingness to make use of primary and good-quality secondary sources. A whole host of later historians have added to the original narrative. Later authors include Trevor Dupuy, Leo de Hartog, James Chambers, Stephen Turnbull, Bevin Alexander, and Richard Gabriel to list a few. They all agree on the brilliance of the Mongols, but cannot agree on operational specifics. This holds true for the 1241 invasion of Central Europe, the 1220 campaign discussed above, and even more for operations in China. None of the cited authors had access to many primary sources. While most know the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secret History")]), _vm._v(" and some of the Muslim sources, the bulk of the Chinese sources have not been properly translated into any European language. Without these it is difficult to go into detail with regard to many military operations of the Mongols.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The military campaigns and operations of notable commanders such as Alexander III (‘the Great’), Hannibal, Caesar, or Napoleon are dealt with in detail in many high-quality works. Authors describe events step by step and consider the decisions taken by the commanders at different points. They review alternatives and evaluate the performance of the key players. Alexander is often faulted for not pursuing the Persians after defeating them at Issus in 333 BC; Hannibal for not marching on Rome in 216 BC; and Caesar for dallying with Cleopatra in Egypt when his foes raised new forces in Africa and Iberia in 47–46 BC. In Belgium in 1815, misunderstandings left the corps of French officer Erlon marching between two battlefields without having an impact on either of them, perhaps denying Napoleon a decisive victory. Napoleon relied on certain strategic ploys he tended to repeat. When he defeated two enemy armies in detail in 1796 it was a novel idea. When he tried the same in 1815 his foes knew what he was up to and did what it took to defeat him. When Federal commander Grant struck into the Wilderness in 1864 he was severely mauled by Confederate commander Lee, but instead of accepting defeat and retreat, as his predecessors would have done, he pushed forward. Though losing more men than Lee, his army was larger and the Union able to replace losses. Lee on the other hand could ill afford to fight a war of attrition. These are samples of military considerations and "), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_vm._v("different situations, be it lost opportunities, impact of friction of war, innovation and the enemy response, or trade-off between a quick victory and reliance on attrition. In the Mongol supermen school, no errors are seen in their conduct, no worn-out strategic ploys fail to surprise the enemy, and no unexpected event derails a plan. This is how Montgomery wanted the world to see the battle of Normandy in 1944, with everything unfolding in accordance with his master plan. It is also how Liddell Hart, Trevor Dupuy, and James Chambers see the Mongol conquest of Transoxiana in 1220 or of Hungary in 1241. Complex plans were implemented with ease, giving the Mongols cheap victories. This, however, does not fit the reality of war. There are always mistakes, misunderstandings, opportunities missed, and surprises. The aim here is to produce a more realistic narrative of the Mongol military campaigns, based on primary and good-quality secondary sources. No a priori assumptions will be taken about the Mongol military brilliance. They would have had to overcome the friction of war as much as Alexander, Hannibal, Napoleon, and other commanders.")])]), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_vm._v("War can be considered in many different ways. The historian John Keegan famously focussed on the experience of battle, how the soldiers actually fought."), _c('span', {
    staticClass: "super"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#note8",
      "id": "footnote8"
    }
  }, [_vm._v("8")]), _vm._v(" This can be called a ‘bottom up’ approach. Strategic movement, numbers, and maps help look at the reality of war from a different angle. This is what will be the initial focus here. Combat is a social action, but statistical laws govern it. At heart, war works like a Lancaster model. One hundred men fighting against 50 in the open with similar weapons, training, and social context will have an advantage. If the 50 men hold a pass or a fortified position, it becomes a different matter. If one side have the advantage of surprise or more supplies, it can again change the context. Trevor Dupuy promoted this type of thinking and developed analytical tools."), _c('span', {
    staticClass: "super"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#note9",
      "id": "footnote9"
    }
  }, [_vm._v("9")])]), _vm._v(" Mongol victories and defeats must be understood in operational context, as the commanders of the period would have seen it. To track events, the focus needs to be on geography, time, and numbers. Numbers and geography are no easy matter, especially with regard to the early wars of the Mongols. What the numbers were is often a matter of guesswork and many locations are either uncertain or not known at all. In the interest of establishing a framework, estimates and guesses will be made. The timing of operations is generally well understood when the theatre of war is in central China, the Near East, or Europe, but much less so in the plains far from sedentary states.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is much still to understand with regard to how Mongols and their foes fought, that is to say the face of battle as well as grand tactical details such as unit deployment, formations, and movement during battle. The sources are far from satisfactory. Certainly there is no description of the kind that, for example, Polybius offers on the battle of Cannae (216 BC) or Arrian offers for the battle of Gaugamela (331 BC). Even so, the sources offer some information. Although not the main emphasis here, the point will be pursued wherever the sources allow it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ‘big man’ theory of history is generally discredited today, though as seen above Napoleon does not agree with this. For sure, Genghis Khan, his general Sübe’etei, the other "), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_vm._v("Mongol commanders, and their foes operated with teams around them. It is difficult to say much about this. The reader should always consider that the commanders functioned in a team and operated in an organisational structure. A little is known about how Genghis Khan managed war as the people around him and his organisation is quite well described in near contemporary sources, but for other key players almost nothing is known.")])]), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is structured into two main sections with the focus being Genghis Khan in the first and Sübe’etei in the second. Before that an overview will be given of the world where Genghis Khan and Sübe’etei operated. Genghis Khan was active from before 1191, to 1227. What he did before 1191 is almost entirely lost to history. Sübe’etei had his first significant independent command in 1216 and retired only just before his death in 1248. They operated jointly in 1220, 1226, and 1227. The last two of these years will be covered in the Sübe’etei section only. The bulk of the narrative is focussed on the campaigns Genghis Khan and Sübe’etei directed in person, but in addition an overview is given of other Mongol campaigns in China (1216–1228 and 1235–1246), and Korea.")]), _vm._v(" "), _c('table', {
    staticClass: "table10"
  }, [_c('colgroup', [_c('col', {
    staticClass: "a50"
  }), _vm._v(" "), _c('col', {
    staticClass: "a50"
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticClass: "th"
  }), _vm._v(" "), _c('th', {
    staticClass: "th"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Section I: Genghis Khan")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Ally of To’oril")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("1191–1202")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Master of Mongolia")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("1203–1208")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("The Chinese Campaigns I")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("1209–1215"), _c('br'), _vm._v("Overview of China, 1215–1227")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("The Great Western Expedition")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("1220–1223")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Section II: Sübe’etei")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Circling the Caspian Sea")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("1216–1224")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("The Chinese Campaigns II")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("1226–1234"), _c('br'), _vm._v("Overview of Korea")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("The European Expedition")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("1236–1242"), _c('br'), _vm._v("Overview of China, 1234–1245"), _c('br'), _vm._v("1245–1246")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The numbers given for armies are rounded and nominal. The effective totals were certainly lower, though by how much is hardly ever known. The nominal totals help give a magnitude even if effective totals could be much lower. This is especially true for infantry forces, the more so the larger they were.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The intention is to render Chinese names in Pinyin format. Quotes, however, will be given in the original format and can therefore be Wade-Giles. Modern names are used for the major cities, such as Beijing or Kaifeng, in China instead of whatever they were called at the time. Chinese administrative districts as well as the main city in them – where the administration was based – were called ‘zhou’, as, for example, Weizhou. ‘Guan’ means ‘pass’. On the maps, places like Weizhou are simply labelled Wei to save space. The Chinese distance measure "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("li")]), _vm._v(" is about half a kilometre. The Chinese standard is to list the family name first.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#footnote1",
      "id": "note1"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Harold Lamb, Genghis Khan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Emperor of All Men")]), _vm._v(" (New York: R. M. McBride and Co., 1927), p.1.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote2",
      "id": "note2"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "foot-sp"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoirs ecrits a Sainte-Helene,")]), _vm._v(" Montholon, volume 2 (Paris, 1847), p.90. Napoleon also counted Gustav II Adolf and Eugene amongst his Great Captains, having in total seven.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote3",
      "id": "note3"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Gavin Long, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("MacArthur as Military Commander")]), _vm._v(" (London: Batsford, 1969), pp.43–44.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote4",
      "id": "note4"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("B.H. Liddell Hart, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scipio Africanus: Greater than Napoleon")]), _vm._v(" (New York: Da Capo Press, 1994), p.257.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote5",
      "id": "note5"
    }
  }, [_vm._v("5")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("The earlier Leon Cahun influenced all three, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction al’histoire de l’Asie; Turcs et Mongols, des origins a 1405")]), _vm._v(" (Paris, 1896).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote6",
      "id": "note6"
    }
  }, [_vm._v("6")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("B. H. Liddell Hart, ‘Two Great Captains: Jenghiz Khan and Sabutai’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blackwood’s Magazine,")]), _vm._v(" vol. 215, p.646.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote7",
      "id": "note7"
    }
  }, [_vm._v("7")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Harold Lamb, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The March of the Barbarians")]), _vm._v(" (New York: Doubleday, Doran & Co., 1940), p.376.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote8",
      "id": "note8"
    }
  }, [_vm._v("8")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("John Keegan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Face of Battle")]), _vm._v(" (Harmondsworth: Penguin, 1983).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#footnote9",
      "id": "note9"
    }
  }, [_vm._v("9")]), _c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("Trevor Dupuy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Numbers, Predictions, and War")]), _vm._v(" (Indianapolis: Bobbs-Merrill, 1979).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-665746fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Introduction.vue
// module id = 72
// module chunks = 0